import React from 'react';
//import {authRoles} from '../../auth';

export const ConceptosUpdateConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/conceptos-details/:id',
        component: React.lazy(() =>
            import ('./ConceptosUpdate'))
    }]
};